import React from 'react'
import { Player } from 'player'
import { Task } from '../../../../types'
import styles from './styles.module.scss'

import { useData } from './use-data'
import { useSettings } from './use-settings'
import { useChannels } from './use-channels'
import { useController } from './use-controller'
import { useInitialStateSingleTrack } from './use-initial-state'
import { useDataExport } from './use-data-export'
import { usePersistedChannelSettings } from '../../../../hooks/player/use-persisted-channel-settings'
import { useModalPaywall } from '../../../../hooks/event/use-modal-paywall'
import { ModalPaywall } from '../../../../components/modal-paywall'

interface SingleTrackType extends Task {
  type: 'mastered' | 'denoised'
  typeOp: 'mastering' | 'denoiser'
  enableExport: boolean
  refetchTask(): void
}

export const SingleTrack: React.FC<SingleTrackType> = (task) => {
  const {
    id: trackId,
    operations: allOperations,
    enableExport,
    typeOp,
    type
  } = task
  const modalPaywall = useModalPaywall()

  const persistedSettings = usePersistedChannelSettings({
    trackId,
    watchChanges: false,
    operationType: 'mastered'
  })

  const data = useData({
    task,
    typeOp
  })

  const channels = useChannels({
    mainOperations: allOperations,
    typeOp,
    type
  })

  const initialState = useInitialStateSingleTrack({
    mainOperations: allOperations,
    persistedSettings
  })

  useDataExport({
    task,
    type,
    typeOp,
    persistedSettings,
    mainOperations: allOperations,
    channels
  })

  const settings = useSettings({
    task,
    type,
    mainOperations: allOperations,
    enableExport
  })

  const controller = useController({
    task,
    mainOperations: allOperations,
    persistedSettings,
    modalPaywall
  })

  return (
    <div className={styles.container}>
      <Player
        data={data}
        channels={channels}
        settings={settings}
        controller={controller}
        initialState={initialState}
        separate={task?.summary?.v1?.separate}
      />

      {modalPaywall.isOpen && <ModalPaywall {...modalPaywall} />}
    </div>
  )
}
